import { useCallback, useEffect, useState } from 'react'

import { IDwUsageStatus, getDwUsageStatus } from '../../Services/datawarehouse'

/**
 * Charge l'état de la mesure.
 *
 * Aucun rafraîchissement automatique : le cron tourne une fois par jour, et un
 * sondage régulier ferait payer des requêtes pour un chiffre qui ne bouge pas.
 * Le rechargement est explicite, après une reprise.
 */
export const useDwUsageStatus = () => {
	const [status, setStatus] = useState<IDwUsageStatus | null>(null)
	const [loading, setLoading] = useState(true)

	const reload = useCallback(() => {
		setLoading(true)
		getDwUsageStatus()
			.then(setStatus)
			.catch(() => setStatus(null))
			.finally(() => setLoading(false))
	}, [])

	useEffect(reload, [reload])

	return { status, loading, reload }
}
